document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            if(item.swiper) return;
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                speed: 2000,
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
                pagination: {
                    el: ".pagination-img",
                    type: "fraction",
                }
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-hero",
                    clickable: true,
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                pagination: {
                    el: ".pagination-galley",
                    type: "fraction",
                }
            });
        });
    }

    let cardSlider = document.querySelectorAll('.card-slider');
    if(cardSlider){
        cardSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                speed: 1000,
                autoHeight: false,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-card",
                    clickable: true,
                },
                breakpoints: {
                    769: {
                        slidesPerView: 4,
                        autoHeight: true,
                    },
                    600: {
                        slidesPerView: 3,
                        autoHeight: true,
                    }
                }
            });
        });
    }

    let sliderCarousel = document.querySelectorAll('.slider-carousel');
    if(sliderCarousel){
        sliderCarousel.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 25,
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".pagination-carousel",
                    type: "fraction",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 'auto',
                    }
                }
            });
        });
    }

});